import React from "react";
import { LoadingDot, LoadingWrapper, WienerImg } from "./styled";
import wienerSrc from "assets/images/minting/wiener.svg";
import { MintContentWrapper, StyledTitle } from "components/Shared/styled";

const WienerLoading = () => {
  return (
    <MintContentWrapper flexDirection="column" justifyContent="center">
      <StyledTitle>Making Your Sausage</StyledTitle>
      <LoadingWrapper justifyContent="center">
        <WienerImg src={wienerSrc} />
        <LoadingDot />
      </LoadingWrapper>
    </MintContentWrapper>
  );
};

export default WienerLoading;
